(function () {

    var formApp = angular.module('formApp');

    // this controller is use executes the functionality in introduction page
    formApp.controller('staffMemberLandingController',
        ['$scope', '$rootScope', '$location', 'adalAuthenticationService', 'UtilityServices', 'DataServices', 'Constants',
            function ($scope, $rootScope, $location, adalAuthenticationService, UtilityServices, DataServices, Constants) {

                // this sets the page title
                document.title = 'Feedback Management System Introduction page';

                DataServices.incidentSubmitted = false;

                $scope.isLoading = false;
                if ($location.path().indexOf('DH') > -1) {
                    $scope.IsDHVisible = true;
                    $scope.IsDFFHVisible = false;
                }
                else {
                    $scope.IsDHVisible = false;
                    $scope.IsDFFHVisible = true;
                }

                // this gets and set the incident config data 
                var getConfigDataForIncidentAndRedirect = function () {
                    $scope.isLoading = true;
                    DataServices.getConfigurationUsingCache(Constants.ConfigTemplate.incident, null, null, DataServices.isAuthenticated())
                        .then(function (data) {
                            $location.path(Constants.Url.firstIncidentFormPage);
                        })
                        .finally(function () {
                            $scope.isLoading = false;
                        });
                }

                $scope.utility = UtilityServices;

                $scope.createIncident = function () {
                    if (!DataServices.isSessionActive()) {
                        adalAuthenticationService.login();
                        return false;
                    }
                    setDefaultValues();
                    getConfigDataForIncidentAndRedirect();
                    $rootScope.allowFormNavigation = true;
                };

                var setDefaultValues = function () {
                    DataServices.originalResponse = {};
                    DataServices.resetResponseInfo();
                    DataServices.responseInfo.status = 1;
                    DataServices.responseInfo.responses = {};
                    DataServices.responseInfo.lastUpdatedTime = null;
                    DataServices.responseInfo.incidentId = null;
                    DataServices.responseInfo.incidentRef = null;
                    DataServices.responseInfo.reportedDate = null;
                    DataServices.responseInfo.status = null;
                    DataServices.responseInfo.submittedDate = null;
                }
            }]);
}());